<template>

  <div>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="processFlowStepRuleCustomerId" :primary-key="form.processFlowStepRuleCustomerId"
                 :foreign-key-column="foreignKeyColumn" :foreign-key="foreignKey"
                 title-items="Clientes vinculados a tolerância"
                 @onSubmit="onSubmit" @onItemRead="onItemReadDefault" @onItemDelete="onItemDeleteDefault">

      <t-input v-model="form.processFlowStepRuleCustomerId" hidden/>

      <b-col cols="12" class="mb-2">

        <b-row>

          <b-col xl="9">

            <b-row>

              <b-col cols="9">
                <t-input-person customer
                                :add-error="error.customerId"
                                v-model="form.customerId" required />
              </b-col>

              <t-input cols="3" v-model="form.note" label="Observações" max-length="500" textarea/>


            </b-row>

          </b-col>

          <b-col xl="3" class="button-form-inline">

            <t-button :sending="status === 'sending'" :text="onButtonSubmitText(command)" no-icon submit/>

            <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
              {{ t('go-back') }}
            </b-link>

          </b-col>


        </b-row>


      </b-col>


    </t-form-list>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import OtherCodeType from "@/model/types/modules/product/OtherCodeType";


export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList},
  name: 'ProcessFlowStepRuleCustomer',
  data() {
    return {
      OtherCodeType,
      path: "production/process-flow-step-rule-customer", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "processFlowStepRuleId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "processFlowStepRuleCustomerId", keyDelete: "processFlowStepRuleCustomerId"},
        {key: "customer", label: "Cliente", cols: "3"},
        {key: "note", label: "Obs.", cols: "5"},
      ],
      form: {
        processFlowStepRuleId: this.foreignKey,
        processFlowStepRuleCustomerId: 0,
        customerId: 0,
        note: "",
        status: 1,

      },
      error: {//Campos que podem receber retorno de erro do backend
        customerId: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      //--------------------------------------------------------------------------------------
    }
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()


    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.processFlowStepRuleCustomerId)

    },

    mountedList() {


      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
